//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";

export default {
  mixins: [aos, foretell],

  data() {
    return {
      showVideo: false,
      companyName: "",
      showSticky: false,
      entityType: "LLC",
      description:
        "<p>Our team of business experts take care of forming your company so you can focus on growing your business.</p><p><br/><strong class='tw-text-azure'>Starting at $0</strong> + state fee</p>",
    };
  },

  props: {
    pageInfo: {
      required: true,
    },
    keyword: {
      required: false,
      default: "Start",
    },
    landerState: {
      required: false,
      default: null,
    },
    landerStateId: {
      required: false,
      default: null,
    },
    packages: {
      required: false,
      default: false,
    },
  },

  methods: {
    goToPage(link, event) {
      this.$router.push(link);
    },
  },

  computed: {
    defaultURL() {
      if (this.pageInfo.fields)
        if (this.packages)
          return (
            `/orders/create/formation/${this.pageInfo.fields.hero_new.table.form}?companyName=` +
            this.companyName +
            "&entity=LLC" +
            "&package=starter"
          );
        else
          return (
            `/orders/create/formation/${this.pageInfo.fields.hero_new.table.form}?companyName=` +
            this.companyName +
            "&entity=LLC" +
            "&state=" +
            this.landerStateId
          );
    },
    hero() {
      if (this.pageInfo.fields) return this.pageInfo.fields.hero_new.table;
    },
  },
  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:business-entity",
      });

      window.addEventListener(
        "scroll",
        () => {
          if (this.$mq.resize) {
            if (this.$mq.above(this.$mv.md)) {
              this.showSticky = window.scrollY > 500;
            } else {
              this.showSticky = window.scrollY > 400;
            }
          }
        },
        { passive: true }
      );
    }
  },
};
